module.exports = __webpack_public_path__ + "static/img/66fd9853929bea4f0f6e821344961587.careDetail1.1709800931122.png";